/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_Col_FromInputs */

const en_pwf_col_from = /** @type {(inputs: Pwf_Col_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current status`)
};

const de_pwf_col_from = /** @type {(inputs: Pwf_Col_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisheriger Status`)
};

/**
* | output |
* | --- |
* | "Current status" |
*
* @param {Pwf_Col_FromInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_col_from = /** @type {((inputs?: Pwf_Col_FromInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_Col_FromInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_col_from(inputs)
	return en_pwf_col_from(inputs)
});